export default __webpack_public_path__ + "assets/images/2afd46577bb36431ac3b5f2c183ed744.svg";